module.exports = __webpack_public_path__ + "static/media/modelo-contrato.2d535ead.pdf";